import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ColorModeProvider } from './theme/ColorModeContext';
import { AuthProvider } from './context/AuthProvider';
import { BranchProvider } from './context/BranchProvider';
import { App } from './App';
import { retryUnlessRateLimited } from './utils/rateLimit';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Once for ordinary failures; never straight back into a 429.
      retry: retryUnlessRateLimited,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ColorModeProvider>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <AuthProvider>
            <BranchProvider>
              <App />
            </BranchProvider>
          </AuthProvider>
        </BrowserRouter>
      </ColorModeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
